import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
      <DefaultInfoCard
       description="HP Tech Solutions will use commercially reasonable efforts to try to resolve the problem at no additional charge. If those efforts are unsuccessful, HP Tech Solutions will refund the fee that is paid for the
        one time Service and NOT REFUND THE FULL AMOUNT." />

      <DefaultInfoCard
       description="As per our refund policy when the experts has completed the work, the call will be automatically routed to the associate
of our call centers and if you are not satisfied with the service, your entire amount will be refunded. And if you are
completely satisfied with our service, you will be given 7 days warranty. If the same issue arises within the next 15 days,
that will be fixed free of cost. In case the customer is not satisfied with our services the money will be refunded only if
he/she contact us within the 7 days from the date of purchase." />
      <DefaultInfoCard
       description="In the event of failure to resolve even a single technical issue within first 15 days of the subscription, HP Tech Solutions shall refund the full subscription amount to the user.

However, if there is one or more technical issues that have been resolved within first 15 days of the subscription, subscription amount will not be refundable to the user. Notwithstanding this, HP Tech Solutions, on a case to case basis, at its sole discretion, may refund the subscription fee after deducting certain servicing charges." />
   <DefaultInfoCard
       description="For instant or one-time plans, refund shall be issued only if the user had all the prerequisites which were required to resolve the technical problem, and the issue was not resolved till the subscription was active. If the technical issue is completely out of scope for one-time plan, HP Tech Solutions will refund the subscription fee to the user. The user will get the refund if the technical issue recurs within 15 days of the last service provided by HP Tech Solutions" />
   </Container>
    </MKBox>
  );
}

export default Information;
